export default "__VITE_ASSET__dff704b4__"